import { render } from "./JuryResetPassword.vue?vue&type=template&id=02c4d2f3&scoped=true"
import script from "./JuryResetPassword.vue?vue&type=script&lang=js"
export * from "./JuryResetPassword.vue?vue&type=script&lang=js"

import "./JuryResetPassword.vue?vue&type=style&index=0&id=02c4d2f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c4d2f3"]])

export default __exports__